import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import {connect} from 'react-redux';
import {ListGroup, ListGroupItem} from '@openfin/desktop-ui';

import {ApplicationEntry} from '../../components/ApplicationEntry/ApplicationEntry';
import {EntityDetailTile} from '../../components/EntityDetailTile/EntityDetailTile';
import {Header} from '../../components/Panel/Header';
import {Panel} from '../../components/Panel/Panel';
import {ROUTES} from '../../../components/Router/consts';
import {Section} from '../../components/Panel/Section';
import {App, AppStatusStates} from '../../../types/commons';
import * as DirectoryIcon from '../../../assets/Directory.svg';
import {RootState} from '../../../store/State';
import {getAppsDirectoryAppList, getPinnedApps, getAppStatuses, AppStatus} from '../../../store/partials/Directory';

import {PinnedApplicationTile} from './PinnedApplicationTile';
import * as Styles from './DirectoryPanel.module.scss';

const mapState = (state: RootState, ownProps) => ({
    apps: getAppsDirectoryAppList(state),
    appStatuses: getAppStatuses(state),
    pinnedApps: getPinnedApps(state),
    ...ownProps
});

interface Props extends RouteComponentProps {
    apps: App[];
    appStatuses: AppStatus;
    pinnedApps: App[];
}

export const DirectoryPanelComponent: React.FC<Props> = (props) => {
    const {apps, appStatuses, pinnedApps, history} = props;
    const [applicationToDetail, setApplicationToDetail] = React.useState<App>(apps[0]);

    const handleClose = () => {
        history.push(ROUTES.HOME);
    };

    const appsSorted = Array.from(apps).sort((a, b) => (a.title || '').toLocaleLowerCase().localeCompare((b.title || '').toLocaleLowerCase()));

    return (
        <Panel>
            <Header title="Directory" onClose={handleClose} icon={DirectoryIcon} />
            <div className={Styles['panel-content']}>

                {pinnedApps.length > 0 && <Section title="Pinned" className={Styles['pinned-applications-pane']}>
                    <ListGroup className={Styles['pinned-application-list']} border={false} horizontal firstItemActive={false} itemActiveBackground={false}>
                        {pinnedApps.map((app) => {
                            return (
                                <ListGroupItem key={app.id} item={app} onHighlight={setApplicationToDetail}>
                                    <PinnedApplicationTile item={app} />
                                </ListGroupItem>
                            );
                        })}
                    </ListGroup>
                </Section>}

                <div className={Styles['flex']}>
                    <Section title="Applications" className={Styles['applications-pane']}>
                        <ListGroup firstItemActive={false}>
                            {appsSorted.map((app) => {
                                return (
                                    <ListGroupItem item={app} onHighlight={setApplicationToDetail} key={app.id}>
                                        <ApplicationEntry item={app} status={appStatuses[app.id] || AppStatusStates.Closed} />
                                    </ListGroupItem>
                                );
                            })}
                        </ListGroup>
                    </Section>

                    <div className={Styles['details-pane']}>
                        <EntityDetailTile entity={applicationToDetail} emptyDescription="You have no applications in your application directory." />
                    </div>

                </div>
            </div>
        </Panel>
    );
};

export const DirectoryPanel = connect(mapState)(DirectoryPanelComponent);
